export default __webpack_public_path__ + "static/media/blue-darken-seasonal.1965223c.svg";